<script>
  export default {
    name: "IconLabel",
    props: {
      title: {
        type: String,
        required: true,
      },
      text: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
        required: true,
      },
      variant: {
        type: String,
        default: "default",
      },
      isDate: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isWrapped: false,
        shouldClamp: false,
        showMore: false,
      };
    },
    methods: {
      checkWrap() {
        this.$nextTick(() => {
          const textEl = this.$refs.textRef;
          if (!textEl) return;
          const computedStyle = window.getComputedStyle(textEl);
          const lineHeight = parseFloat(computedStyle.lineHeight);
          const height = textEl.offsetHeight;

          const lineCountRounded = Math.round(height / lineHeight);
          const showMoreLineCount = Math.floor(height / lineHeight);
          this.isWrapped = lineCountRounded > 1;
          this.shouldClamp = showMoreLineCount > 3;
        });
      },
    },
    watch: {
      text: {
        handler() {
          this.checkWrap();
        },
        immediate: true,
      },
    },
    mounted() {
      this.checkWrap();
    },
  };
</script>

<template>
  <div :class="['IconLabel', `IconLabel--${variant}`, { 'IconLabel--wrap': isWrapped }]">
    <div class="IconLabel__textBold">
      <iconic :name="icon" class="IconLabel__icon" />
      {{ title }}
    </div>
    <div class="IconLabel__textContainer">
      <span ref="textRef" class="IconLabel__text" :class="{ 'IconLabel__text--clamped': shouldClamp && !showMore }">
        <strong v-if="isDate">{{ text }}</strong>
        <template v-else>{{ text }}</template>
      </span>
      <span v-if="shouldClamp" class="IconLabel__toggle" @click="showMore = !showMore">
        {{ showMore ? "Ver menos." : "Ver más." }}
      </span>
    </div>
  </div>
</template>

<style lang="scss">
  .IconLabel {
    @include Flex(row, flex-start, flex-start);
    width: 100%;
    gap: 5px;
    &__textBold {
      @include Flex();
      color: #3d3d3d;
      font-family: $newFont_regular;
      gap: 6px;
    }
    &__text {
      overflow-wrap: anywhere;
      color: #3d3d3d;
      font-family: $newFont_regular;
      &--clamped {
        display: -webkit-box;
        line-clamp: 3;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
    &__icon {
      font-size: 15px;
    }
    &__toggle {
      display: inline-block;
      color: $primary-color;
      font-weight: bold;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    &--wrap {
      flex-direction: column;
      gap: 0px;
      .IconLabel__textContainer {
        margin-left: 19px;
      }
    }
    &--red {
      .IconLabel__textBold {
        color: $primary-color;
      }
    }
  }
</style>
